// ═══════════════════════════════════════════════════════════════
// AutoRefreshImage — appends a cache-buster to the src every N
// seconds so snapshot cameras look like a low-framerate live feed.
// ═══════════════════════════════════════════════════════════════

import { useState, useEffect } from 'react';

interface Props {
  src: string;
  alt?: string;
  intervalMs?: number;
  style?: React.CSSProperties;
}

export default function AutoRefreshImage({ src, alt, intervalMs = 5000, style }: Props) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  if (!src) return null;

  const bustUrl = `${src}${src.includes('?') ? '&' : '?'}_t=${tick}`;

  return (
    <img
      src={bustUrl}
      alt={alt || ''}
      style={{ width: '100%', borderRadius: 4, display: 'block', ...style }}
      loading="lazy"
    />
  );
}
